import React from 'react';
import PropTypes from 'prop-types';

import { Alert as BootstrapAlert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';

const ICON = {
  success: faCheckCircle,
  warning: faExclamationCircle,
  info: faSpinner,
  danger: faExclamationTriangle,
};

const propTypes = {
  variant: PropTypes.oneOf(['danger', 'success', 'info', 'warning']),
  title: PropTypes.string,
  containerClass: PropTypes.string,
  iconProps: PropTypes.shape({
    className: PropTypes.string,
    spin: PropTypes.bool,
    pulse: PropTypes.bool,
  }),
  children: PropTypes.node,
};

const defaultProps = {
  variant: 'info',
  title: '',
  containerClass: '',
  iconProps: {},
  children: undefined,
};

export default function Alert({
  variant,
  title,
  containerClass,
  iconProps,
  children,
  ...props
}) {
  return (
    <BootstrapAlert
      variant={variant}
      title={title}
      className={containerClass}
      {...props}
    >
      <FontAwesomeIcon icon={ICON[variant]} {...iconProps} /> {children}
    </BootstrapAlert>
  );
}

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
